
import React from "react";
import { CommandEmpty, CommandGroup, CommandSeparator } from "@/components/ui/command";
import { SearchResultItem } from "./SearchResultItem";
import type { SearchResult } from "@/hooks/useSearch";

interface SearchResultsProps {
  isLoading: boolean;
  query: string;
  results: {
    users: SearchResult[];
    groups: SearchResult[];
    prompts: SearchResult[];
  };
  onSelect: (result: SearchResult) => void;
}

export function SearchResults({ isLoading, query, results, onSelect }: SearchResultsProps) {
  const hasUsers = results.users.length > 0;
  const hasGroups = results.groups.length > 0;
  const hasPrompts = results.prompts.length > 0;
  
  return (
    <>
      <CommandEmpty>
        {isLoading ? (
          <div className="py-6 text-center text-sm">Searching...</div>
        ) : (
          query.length > 0 ? 
            "No results found." : 
            "Type at least 2 characters to search..."
        )}
      </CommandEmpty>

      {hasUsers && (
        <CommandGroup heading="Users">
          {results.users.map((user) => (
            <SearchResultItem 
              key={user.id} 
              result={user}
              onSelect={onSelect}
            />
          ))}
        </CommandGroup>
      )}

      {hasGroups && (
        <>
          {hasUsers && <CommandSeparator />}
          <CommandGroup heading="Communities">
            {results.groups.map((group) => (
              <SearchResultItem 
                key={group.id} 
                result={group}
                onSelect={onSelect}
              />
            ))}
          </CommandGroup>
        </>
      )}
      
      {hasPrompts && (
        <>
          {(hasUsers || hasGroups) && <CommandSeparator />}
          <CommandGroup heading="Prompts">
            {results.prompts.map((prompt) => (
              <SearchResultItem 
                key={prompt.id} 
                result={prompt}
                onSelect={onSelect}
              />
            ))}
          </CommandGroup>
        </>
      )}
    </>
  );
}
